import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import RightsAware from '@/lib/mixins/rights-aware';
import { DynPanelAware } from './dyn-panel';

@Component
export default class CollectionControl extends Mixins(RightsAware, DynPanelAware) {

  @Prop({default: () => []}) readonly data!: any[];
  @Prop({default: false}) readonly readonly!: boolean;
  @Prop({required: false}) readonly clazz: Function;
  @Prop({required: false, default: true}) readonly withAddButton: boolean;

  onClickAdd() {
    if (!this.clazz || (this.$listeners && this.$listeners.add)) {
      this.$emit("add");
    } else {
      this.pushPanel({
        clazz: this.clazz,
        on: {
          commit: ({emitter, data: d}) => (this.data.push(d), emitter.remove())
        }
      });
    }
  }

  onEdit(d) {
    this.pushPanel({
      clazz: this.clazz,
      props: {edit: d, readonly: this.isReadonly},
      on: {
        commit: ({emitter, data: modified}) => (Object.assign(d, modified), emitter.remove())
      }
    });
  }

  onDelete(d) {
    this.data.splice(this.data.indexOf(d), 1);
  }

  render() {
    return (
      <div class="control inline-table-control">
        {(!this.data || !this.data.length) ? (
          <div class="is-fluid is-flex justify-space-between align-center no-data-content">
            <span class="is-size-7 has-text-grey"><i>Aucun enregistrement</i></span>
            {!this.isReadonly && this.withAddButton && <a class="add-button" onClick={this.onClickAdd}>Ajouter</a>}
          </div>
        ) : (
          <div class="data-content">
            {this.$scopedSlots.body && this.$scopedSlots.body({data: this.data, onEdit: this.onEdit, onDelete: this.onDelete })}
            {!this.isReadonly && this.withAddButton && (
            <div class="is-flex justify-flex-end">
              <a class="add-button" onClick={this.onClickAdd}>Ajouter</a>
            </div>
            )}
          </div>
        )}
      </div>
    )
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-82d1985c/collection-control.tsx" });